import { render, staticRenderFns } from "./questionnaireItemTab.vue?vue&type=template&id=4f82f960&scoped=true&"
import script from "./questionnaireItemTab.vue?vue&type=script&lang=js&"
export * from "./questionnaireItemTab.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireItemTab.vue?vue&type=style&index=0&id=4f82f960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f82f960",
  null
  
)

export default component.exports